// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import PaginationDataResourceViewModel from '../../../../viewModel/resource/PaginationDataResourceViewModel';
import PaginationDataResourceDTO from '../../dto/resource/PaginationDataResourceDTO';

export default abstract class PaginationDataResourceModel extends BaseModel<PaginationDataResourceDTO> {
  /**
  * @type {int32}
  */
  get totalCount() { return this.dto.totalCount; }
  set totalCount(value) { this.dto.totalCount = value; }
  /**
  * @type {int32}
  */
  get pageSize() { return this.dto.pageSize; }
  set pageSize(value) { this.dto.pageSize = value; }
  /**
  * @type {int32}
  */
  get currentPage() { return this.dto.currentPage; }
  set currentPage(value) { this.dto.currentPage = value; }
  /**
  * @type {int32}
  */
  get totalPages() { return this.dto.totalPages; }
  /**
  */
  get previousPage() { return this.dto.previousPage; }
  /**
  */
  get nextPage() { return this.dto.nextPage; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.totalcount);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.totalCount = value;
    value = Number.parseFloat(qs.pagesize);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.pageSize = value;
    value = Number.parseFloat(qs.currentpage);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.currentPage = value;
  }
}
